import { useEffect } from "react";

/**
 * Injects a JSON-LD structured data script into <head>.
 * Removes it when the component unmounts / data changes.
 */
export default function JsonLd({ data, id }) {
  useEffect(() => {
    if (!data) return;
    const scriptId = id || `jsonld-${Math.random().toString(36).slice(2)}`;
    let el = document.getElementById(scriptId);
    if (!el) {
      el = document.createElement("script");
      el.type = "application/ld+json";
      el.id = scriptId;
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(data);
    return () => {
      const cleanup = document.getElementById(scriptId);
      if (cleanup) cleanup.remove();
    };
  }, [data, id]);
  return null;
}
